module.exports = __webpack_public_path__ + "static/Mobile_4@2x-3248cda7c93b29a82911c22e39f411cf.png";